export let paymentTermListProps = {
    key: 0,
    id: 0,
    day_count: 0,
    percent_of_amount: 0
}

export let dataProps = {
    id: 0,
    trackable_item_vendor: true,
    vendor_name: '', 
    brand_name: '',  
    contact_person_name: '', 
    contact_number: '',
    email_address: '',
    tax_information: '',
    address: '',
    city_id: null,
    province_id: null,
    postal_code: '',
    country_id: null,
    bank_detail: '',
    additional_notes: '',
    billing_currency_id: null,
    account_sub_category_id: null,
    account_related_sub_category_id: null,
    
    payment_term_list: [],
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorMaster/properties.js